// extracted by mini-css-extract-plugin
export var card = "_7l-1";
export var container = "_7l-0";